// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/Dashboard.tsx
// ═══════════════════════════════════════════════════════════════

import { useQuery } from "@tanstack/react-query";
import { DashboardApi } from "../lib/api";

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ["dashboard"],
    queryFn: DashboardApi.stats,
    refetchInterval: 30_000,
  });

  const cards = [
    { label: "Partners", value: stats?.totalPartners ?? 0, color: "bg-blue-500" },
    { label: "Products", value: stats?.totalProducts ?? 0, color: "bg-green-500" },
    { label: "Leads/Opportunities", value: stats?.totalLeads ?? 0, color: "bg-purple-500" },
    { label: "Sales Orders", value: stats?.totalOrders ?? 0, color: "bg-orange-500" },
    { label: "Pipeline Revenue", value: `$${(stats?.pipelineRevenue ?? 0).toLocaleString()}`, color: "bg-teal-500" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
            {cards.map((card) => (
              <div key={card.label} className="bg-white rounded-xl shadow-sm border p-5">
                <div className={`w-3 h-3 rounded-full ${card.color} mb-2`} />
                <p className="text-2xl font-bold">{card.value}</p>
                <p className="text-sm text-gray-500 mt-1">{card.label}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl shadow-sm border p-5">
              <h2 className="font-semibold mb-3">Quick Actions</h2>
              <div className="space-y-2">
                <a href="/partners/new" className="block px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100">
                  + New Partner
                </a>
                <a href="/orders/new" className="block px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100">
                  + New Sales Order
                </a>
                <a href="/crm/new" className="block px-4 py-2 bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100">
                  + New Lead
                </a>
                <a href="/products/new" className="block px-4 py-2 bg-orange-50 text-orange-700 rounded-lg hover:bg-orange-100">
                  + New Product
                </a>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border p-5">
              <h2 className="font-semibold mb-3">Recent Activity</h2>
              <p className="text-sm text-gray-500">Activity tracking coming soon.</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
